// TODO: Find where we need this
export const project = 'taggingng'; // need this for when we dynamically import utils

const gtmMapping = {
	'nissan-t3-tagging-TrackPageLoad': {
		event: 'general.bottom.of.page'
	},
	'nissan-t3-tagging-TrackToggle': {
		uniqueEvent: 'showroom-toggle',
		event: 't3TrackToggle'
	},
	'nissan-t3-tagging-TrackAccordion': {
		uniqueEvent: 'detailed-specs-accordion',
		event: 't3TrackAccordion'
	},
	'nissan-t3-tagging-TrackLinkClick': {
		event: [
			'text.link',
			'button.link',
			'generic.link',
			'link.hproduct.click',
			'image.link',
			'nav.link',
			't3TrackLinkClick'
		]
	},
	'nissan-t3-tagging-TrackDownloadBrochure': {
		event: ['t3TrackDownloadBrochure']
	},
	'nissan-t3-tagging-TrackDropDown': {
		event: 't3TrackDropDown'
	},
	'nissan-t3-tagging-TrackSignIn': {
		formName: 'Mycars Login',
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackSignUp': {
		formName: 'Mycars Register',
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackServiceAppointment': {
		formName: 'Schedule Service',
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackHandraiserFormSuccess': {
		formName: [
			'Navigation General Contact',
			'General Contact',
			'VDP:Email a friend',
			'VLP:Navigation General Contact'
		],
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackTestDriveFormSuccess': {
		formName: 'VDP:Test Drive',
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackLeadFormSuccess': {
		event: 'form.confirmation'
	},
	'nissan-t3-tagging-TrackInventoryResults': {
		event: 't3TrackInventoryResults'
	},
	'nissan-t3-tagging-TrackInventoryResultsKvp': {
		event: 't3TrackInventoryResultsKvp'
	},
	'nissan-t3-tagging-TrackClickToCall': {
		event: 'telephone.dial'
	},
	'nissan-t3-tagging-TrackCarousel': {
		event: ['arrow.next', 'arrow.prev']
	},
	'nissan-t3-tagging-TrackOfferDetails': {
		event: 't3TrackOfferDetails'
	},
	'nissan-t3-tagging-TrackVideoPlay': {
		event: 'vdp.video.play'
	},
	'nissan-t3-tagging-TrackVideoCompleted': {
		event: 'vdp.video.complete'
	},
	'nissan-t3-tagging-TrackColorPicker': {
		event: 't3TrackColorPicker'
	},
	'nissan-t3-tagging-TrackPaymentEstimator': {
		event: 'form.payment.calc.init',
		eventOnly: true
	}
};

/**
 * Returns the gtm event name given the source event information.
 *
 * @param {string} sourceUniqueEvent
 * @param {string} sourceEvent
 * @param {string} sourceFormName
 * @returns {string} The gtm name event
 *
 * If sourceUniqueEvent is in the map return the map
 * If no formName in the map, or the sourceFormName found in the map then...
 *  check for matching event in the map and if found return the key
 *
 *  Mappings live in the ws-tagging OSIRIS widget
 */
const mapGTMs = (
	sourceUniqueEvent = '',
	sourceEvent = '',
	sourceFormName = ''
) => {
	const key = Object.entries(gtmMapping).find(([, gtmEventInfo]) => {
		const { event, formName, uniqueEvent } = gtmEventInfo;

		if (uniqueEvent === sourceUniqueEvent) {
			return true;
		}

		const formNameExists = formName !== undefined;
		const formNameMatch = formNameExists && formName === sourceFormName;
		const formNameIncludes =
			formNameExists && Object.values(formName).includes(sourceFormName);

		if (!formNameExists || formNameMatch || formNameIncludes) {
			if (
				event &&
				(event === sourceEvent ||
					Object.values(event).includes(sourceEvent))
			) {
				return true;
			}
		}

		return false;
	});

	return {
		event: key?.[0],
		eventOnly: key?.[1]?.eventOnly
	};
};

const t3TrackLinkClickPageAliases = [
	'NISSAN_EV_CENTER',
	'EV_BENEFITS',
	'HOME_CHARGING'
];

export const groupingSending = ({ data = {}, win = {} }) => {
	let payload;
	const { pageName } = win?.DDC?.dataLayer?.page?.pageInfo || {};
	const {
		additionalData = {},
		additionalData: { formName, uniqueEvent } = {},
		directCallEvent
	} = data;
	let additionalDataForGTM = additionalData;
	let renamedDirectCalledEvent = directCallEvent;

	if (
		directCallEvent === 'button.link' &&
		t3TrackLinkClickPageAliases.some((t3TrackLinkClickPageAlias) =>
			pageName.includes(t3TrackLinkClickPageAlias)
		)
	) {
		renamedDirectCalledEvent = 't3TrackLinkClick';
	}

	const { event: gtmEventName, eventOnly } = mapGTMs(
		uniqueEvent,
		directCallEvent,
		formName
	);

	if (gtmEventName === 'nissan-t3-tagging-TrackPageLoad') {
		additionalDataForGTM = {
			...(win?.digitalData?.pageInfo || {}),
			...(win?.digitalData?.vehicleInfo || {}),
			...(win?.digitalData?.visitorProfile || {})
		};
	}

	if (win?.DDC?.pushToGtmDataLayer && gtmEventName) {
		payload = {
			event: gtmEventName,
			...(!eventOnly && {
				'nissan-t3-tagging': additionalDataForGTM
			})
		};
		win.DDC.pushToGtmDataLayer(payload);
	}

	return {
		directCallEvent: renamedDirectCalledEvent,
		payload
	};
};

export const getShortFranchises = () => 'na';

export const getDealerBac = () => {
	// get the dealerCode if found or undefined
	const foundObject = window?.DDC?.dataLayer?.dealership?.dealerCode?.find(
		({ nissanoem } = {}) => nissanoem
	);

	return (
		foundObject?.nissanoem ||
		'Account {} not configured with a BAC dealer code'
	);
};
